import {
  InternationalIncomePresetModel,
  CreateInternationalIncomePresetModel,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class InternationalIncomePresetService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  getList(options: IRequestOptions = {}): Promise<InternationalIncomePresetModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/InternationalIncomePreset/GetList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  create(
    params: {
      /** requestBody */
      body?: CreateInternationalIncomePresetModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternationalIncomePresetModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/InternationalIncomePreset/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  getById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternationalIncomePresetModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/InternationalIncomePreset/GetById';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
